import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const JOB_BASE = process.env.REACT_APP_JOB_CREATE_BASE || "";

export const postJobApply = createAsyncThunk(
  "postJobApply",
  async (appData: any) => {
    try {
      const { data } = await axios.post(
        `${GATEWAY_BASE + JOB_BASE}/api/v1/firm/jobs/apply`,
        appData
      );
      return data;
    } catch (error: any) {
      // Throw the entire error object to be caught in the rejected case
      throw error.response?.data || error.message;
    }
  }
);

const postJobApplySlice = createSlice({
  name: "postJobApply",
  initialState: {
    loading: false,
    applyResponse: null as any,
    error: false,
    errorData: null as any,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(postJobApply.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(postJobApply.fulfilled, (state, action) => {
      state.loading = false;
      state.applyResponse = action.payload;
    });
    builder.addCase(postJobApply.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorData = action.error;
    });
  },
});

export default postJobApplySlice.reducer;
